import React, { useState, useContext, useEffect } from "react";
import Loader from "../../../components/Loader";
import { UserServiceContext } from "../../../services/user/userService";
import CustomAlert from "../../../components/CustomAlert";
import MaskedInput from "react-text-mask";
import SearchableSelect from "../../../components/SearchableSelect";
import { use } from "react";

const NewAddressContactModal = ({
  setCreateEventModal,
  show,
  isEdit,
  contact,
  cities,
  id,
}) => {
  const { loading, userFavoriteContactAdd, userFavoriteContactUpdate } =
    useContext(UserServiceContext);
  const [errors, setErrors] = useState({});
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });
  const [formData, setFormData] = useState({
    userFavoriteClientId: "",
    name: "",
    cityId: "",
    contactPhone: "",
    address: "",
    cityName: "აირჩიეთ",
  });

  useEffect(() => {
    if (isEdit && contact) {
      setFormData({
        id: contact.id || "",
        userFavoriteClientId: contact.userFavoriteClientId || "",
        name: contact.name || "",
        cityId: contact.cityId || "",
        contactPhone: contact.contactPhone || "",
        address: contact.address || "",
        cityName: contact.cityName || "აირჩიეთ",
      });
    }
  }, [contact]);

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "contactPhone") {
      value = value.replace(/[^0-9]/g, "");
    }

    // if (typeof value === "string") {
    //   value = value.trim();
    // }

    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (val) => {
    const city = cities.find((city) => city.name === val);
    if (city) {
      setFormData({ ...formData, cityName: city.name, cityId: city.id });
    }
  };

  const validateForm = () => {
    let formIsValid = true;
    let errors = {};
    if (!formData.name) {
      formIsValid = false;
      errors["name"] = "სახელი აუცილებელია";
    }
    if (!formData.contactPhone) {
      formIsValid = false;
      errors["contactPhone"] = "ტელეფონის ნომერი აუცილებელია";
    }
    if (!formData.address) {
      formIsValid = false;
      errors["address"] = "მისამართი აუცილებელია";
    }

    if (!formData.cityId) {
      formIsValid = false;
      errors["cityId"] = "ქალაქი აუცილებელია";
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();
    if (!isValid) return;

    const trimmedFormData = Object.keys(formData).reduce((acc, key) => {
      const value = formData[key];
      acc[key] = typeof value === "string" ? value.trim() : value;
      return acc;
    }, {});

    if (isEdit) {
      console.log(trimmedFormData);
      const dt = { ...trimmedFormData, id: trimmedFormData.id };
      const response = await userFavoriteContactUpdate(dt);
      if (response && response.data.success) {
        setCreateEventModal(true);
      } else {
        setAlertConfig({
          show: true,
          title: "შეცდომა",
          text: response.data.message,
          icon: "error",
          onCancel: () => setAlertConfig({ ...alertConfig, show: false }),
        });
      }
    } else {
      
      const response = await userFavoriteContactAdd({
        ...trimmedFormData,
        userFavoriteClientId: id,
      });
      if (response && response.data.success) {
        setCreateEventModal();
      } else {
        setAlertConfig({
          show: true,
          title: "შეცდომა",
          text: response.data.message,
          icon: "error",
          onCancel: () => setAlertConfig({ ...alertConfig, show: false }),
        });
      }
    }
  };

  return (
    <>
      {loading && <Loader />}
      <CustomAlert {...alertConfig} />
      <div
        className={`fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]`}
      >
        <div className="py-10 md:px-10 px-[7px] bg-card-color rounded-lg shadow-shadow-lg">
          <div className="my-10 lg:px-20 md:px-10 px-[7px] md:max-h-[80svh] max-h-[60svh] overflow-auto custom-scrollbar">
            <div className="text-[24px]/[30px] font-medium mb-2">
              კონტაქტის {isEdit ? "რედაქტირება" : "დამატება"}
            </div>
            <div className="text-[14px]/[20px] font-medium mb-2">
              <form onSubmit={handleSubmit}>
                <div className="form-control mb-15">
                  <label htmlFor="name" className="form-label">
                    სახელი
                  </label>
                  <input
                    id="name"
                    placeholder="სახელი"
                    required
                    className="form-input"
                    name="name"
                    value={formData.name}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.name && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.name}
                    </div>
                  )}
                </div>
                <div className="form-control mb-15">
                  <label htmlFor="cityId" className="form-label">
                    ქალაქი
                  </label>
                  <SearchableSelect
                    options={cities}
                    label="name"
                    id="id"
                    selectedVal={formData.cityName}
                    handleChange={(val) => handleSelectChange(val)}
                  />
                  {errors.cityId && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.cityId}
                    </div>
                  )}
                </div>
                <div className="form-control mb-15">
                  <label htmlFor="contactPhone" className="form-label">
                    ტელეფონი
                  </label>
                  <MaskedInput
                    mask={[
                      "(",
                      /[0-9]/,
                      /\d/,
                      /\d/,
                      ")",
                      " ",
                      /\d/,
                      /\d/,
                      /\d/,
                      "-",
                      /\d/,
                      /\d/,
                      /\d/,
                    ]}
                    guide={true}
                    id="contactPhone"
                    placeholder="(555) 555-555"
                    required
                    className="form-input"
                    name="contactPhone"
                    value={formData.contactPhone}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.contactPhone && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.contactPhone}
                    </div>
                  )}
                </div>
                <div className="form-control mb-15">
                  <label htmlFor="address" className="form-label">
                    მისამართი
                  </label>
                  <input
                    id="address"
                    placeholder="მისამართი"
                    required
                    className="form-input"
                    name="address"
                    value={formData.address}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.address && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.address}
                    </div>
                  )}
                </div>
                <div className="flex items-stretch gap-5">
                  <button className="btn btn-primary" type="submit">
                    შენახვა
                  </button>
                  <button
                    onClick={() => setCreateEventModal(false)}
                    className="btn btn-secondary"
                    type="button"
                  >
                    გაუქმება
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={() => setCreateEventModal(false)}
        className={`contents-[] fixed z-[5] w-full h-full left-0 top-0 bg-black-50 backdrop-blur-[2px]`}
      ></div>
    </>
  );
};

export default NewAddressContactModal;
